import { AnalyticsId } from "../types"

export const BALANCE_UPDATE_INTERVAL = 90_000

export const BORROW_UPDATE_INTERVAL = 30_000

export const WAGMI_CONNECTOR_ID = {
  walletConnect: "walletConnect",
  okx: "okx",
}

export const WALLET_ANALYTICS_ID: Record<string, AnalyticsId> = {
  taho: AnalyticsId.TAHO_WALLET,
  metaMask: AnalyticsId.METAMASK_WALLET,
  walletConnect: AnalyticsId.ZERION_WALLET,
  okx: AnalyticsId.OKX_WALLET,
  "orangekit-unisat": AnalyticsId.UNISAT_WALLET,
  "orangekit-okx": AnalyticsId.OKX_BTC_WALLET,
  "orangekit-xverse": AnalyticsId.XVERSE_WALLET,
}
